export const VIRGIL_SERVER_URL = 'https://virgil.cpslearn.co.za';

export function resolveApiBaseUrl(apiBaseUrl) {
  if (typeof apiBaseUrl === 'string' && apiBaseUrl) {
    return apiBaseUrl.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.VIRGIL_API_URL) {
    return String(window.VIRGIL_API_URL).replace(/\/$/, '');
  }
  return VIRGIL_SERVER_URL;
}

function hostOf(url) {
  try {
    return new URL(url, typeof window !== 'undefined' ? window.location.href : 'https://virgil.cpslearn.co.za').host;
  } catch (_) {
    return '';
  }
}

export function resolveWebsocketUrl(websocketUrl, apiBaseUrl) {
  const api = resolveApiBaseUrl(apiBaseUrl);
  let ws = '';
  if (typeof websocketUrl === 'string' && websocketUrl) {
    ws = websocketUrl.replace(/\/$/, '');
  } else if (typeof window !== 'undefined' && window.VIRGIL_WS_URL) {
    ws = String(window.VIRGIL_WS_URL).replace(/\/$/, '');
  }
  // Presence must hit the Virgil API host. LMS pages often pass window.location.origin.
  if (ws && api && hostOf(ws) && hostOf(api) && hostOf(ws) !== hostOf(api)) {
    return api;
  }
  return ws || api || VIRGIL_SERVER_URL;
}
